<template>
  <modal :max-width="925" @close="$emit('closeUserModal', 'Find User')">
    <div class="modal-box">
      <h4 class="pb-4">User Detail</h4>
      <div class="table-responsive">
        <table class="table table-bordered table-hover">
          <thead class="thead-dark">
            <tr>
              <th scope="col">Key</th>
              <th scope="col">Value</th>
            </tr>
          </thead>
          <tbody>

            <tr v-for="item in tableData" :key="item[0]">
              <th class="text-capitalize d-flex justify-content-between" >
                <span>{{ item[0] }}</span>
                <span>&nbsp;</span>
                <span class="cursor-pointer"><i class="fa fa-clone text-muted cursor-pointer" aria-hidden="true" @click="() => copyToClipBoard(item[1])"></i></span>
              </th>
              <td>{{ item[1] }}</td>
            </tr>
            <tr>
              <th class="text-capitalize d-flex justify-content-start" >Login</th>
              <td v-if="loginLoading" class="text-primary">Loading...</td>
              <td v-else><i class="fa fa-power-off text-primary cursor-pointer" aria-hidden="true" @click="() => {loginToAgency(user.id)}"></i> </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </modal>
</template>

<script>
import modal from '@/components/common/Modal.vue'
import defaults from "@/config";
import { InternalToolsService } from '@/services';

export default {
  components: { modal },
  props: {
    company: Object,
    user: Object,
  },
  data(){
    return {
      expectedUserTableValues: ['id', 'name', 'email', 'roles', 'companyId', 'locations'],
      expectedCompanyTableValues: ['relationship_number'],
      tableData: [],
      loginLoading: false
    }
  },
  mounted(){
    this.createTableData()
  },
  methods: {
    createTableData(){
      this.expectedUserTableValues.forEach(data => {
        Object.entries(this.user).forEach(eachProperty => {
          if(data === eachProperty[0]){
            if (eachProperty[0] === 'roles') {
              this.tableData = [...this.tableData, ['role', eachProperty[1].role], ['type', eachProperty[1].type]]
            } else if (eachProperty[0] === 'locations'){
              if(Object.keys(eachProperty[1]).length){
                this.tableData = [...this.tableData, ['location Id', Object.keys(eachProperty[1]) ]]
              }
            } else {
              this.tableData = [...this.tableData, eachProperty]
            }
          }
        })
      })
      this.expectedCompanyTableValues.forEach(data => {
        Object.entries(this.company).forEach(eachProperty => {
          if(data === eachProperty[0]){
            this.tableData = [...this.tableData, eachProperty]
          }
        })
      })
    },
    copyToClipBoard(text){
      const textElem = document.createElement("textarea");
      textElem.innerHTML = text;
      document.body.appendChild(textElem);
      textElem.select();
      document.execCommand("copy");
      navigator.clipboard.writeText(textElem.value);
      document.body.removeChild(textElem);
      alert('copied')
    },
    async loginToAgency(userId){
      try {
        this.loginLoading = true
        if (userId) {
          let env =
            defaults.mode === "dev" ? "local" : defaults.mode === "staging" ? "staging" : "prod";
          try {
            const response = await InternalToolsService.initLogin({
              loginBy: "USER_ID",
              platform: "WEB",
              value: userId,
            });
            let baseUrl
            if (env == "local") baseUrl = `http://localhost:8080`;
            else if (env == "beta") baseUrl = `https://beta.gohighlevel.com`;
            else if(env == 'staging') baseUrl = `https://staging.gohighlevel.com`;
            else baseUrl = `https://app.gohighlevel.com`;
            window.open(baseUrl + response.data.url, '_blank')
          } catch (err) {
            console.log(err)
            if (err && err.response && err.response.data === "Unauthorized") {
              alert("Session Timeout - Please Login");
            } else {
              alert("Something went wrong");
            }
          }
        }
        this.loginLoading = false
      } catch (e) {
        console.log(e)
        alert('Login error')
        this.loginLoading = false
      }
    }
  }
}
</script>
<style lang="scss">
.modal-box {
  padding: 24px;

  .multiple-users-box {
    margin-bottom: 18px;

    .type {
      margin-bottom: 0;
      font-size: 14px;
    }

    .value {
      margin-bottom: 0;
      font-size: 16px;
      font-weight: bold;
      opacity: 0.84;
    }
  }
}

.cursor-pointer{
  cursor: pointer;
}
</style>
